import dayjs from "dayjs";
import "dayjs/locale/sv";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import duration from "dayjs/plugin/duration";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isBetween from "dayjs/plugin/isBetween";
import customParseFormat from "dayjs/plugin/customParseFormat";

import "./menu";
import "./modules/Toggle";

import "./blocks/Slider";
import "./blocks/FormBlock";

import "./react/S3Booking/S3BookingApp";
import "./react/S3Booking/QuickSearchBox/QuickSearchBox";
import "./react/S3Booking/PaymentReturn/PaymentReturnApp";
import "./react/S3Booking/ManageBooking/ManageBookingApp";



import "./feedbackpopup";
import { runIfDev } from "./utils";

runIfDev(() => console.debug("We are in development mode!"));


//Konfigurera locale för dayjs
if (document?.documentElement.lang.indexOf("sv") >= 0)
{
	dayjs.locale("sv");
}
else
{
	dayjs.locale("en");
}

dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(duration);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);
dayjs.extend(customParseFormat);